import React from "react";
import PropTypes from "prop-types";
import { Grid } from "@material-ui/core";

const MainItemsLayout = ({ leftContent, rightContent, button }) => (
  <>
    <Grid
      container
      item
      direction="row"
      justifyContent="center"
      alignItems="flex-start"
    >
      <Grid item xs={12} md={6}>
        {leftContent}
      </Grid>
      <Grid container item xs={12} md={6} justifyContent="center">
        {rightContent}
      </Grid>
    </Grid>
    {button && (
      <Grid container item justifyContent="center" alignItems="center">
        <Grid item>{button}</Grid>
      </Grid>
    )}
  </>
);

MainItemsLayout.propTypes = {
  leftContent: PropTypes.node.isRequired,
  rightContent: PropTypes.node.isRequired,
  button: PropTypes.node,
};

MainItemsLayout.defaultProps = {
  button: undefined,
};

export default MainItemsLayout;
